import { inject, Injectable } from '@angular/core';
import { StaticStorage } from '../static-storage';
import { HttpClient } from '@angular/common/http';
import { Observable, tap } from 'rxjs';
import { httpRetry } from '$core/helpers/http-retry';
import { IndividualIdentificationDataDto } from '../types';

@Injectable({
  providedIn: 'root',
})
export class IndividualIdentificationService {
  private readonly http = inject(HttpClient);
  private readonly staticStorage = inject(StaticStorage);

  public getIndividualIdentificationStatics(): Observable<unknown> {
    return this.http.get<unknown>('/v2/individual-identification-data').pipe(
      httpRetry(5),
      tap((res: IndividualIdentificationDataDto) => {
        this.staticStorage.updateStatic(res);
      })
    );
  }
}
